import AWS from 'aws-sdk'

AWS.config.update({
    accessKeyId: process.env.VUE_APP_AWS_ACCESS_KEY,
    secretAccessKey: process.env.VUE_APP_AWS_SECRET_KEY,
    region: 'us-east-1'
})

const s3 = new AWS.S3({
    signatureVersion: 'v4',
    endpoint:          'https://lithium-60.object.pscloud.io',
    s3BucketEndpoint:  true
})

export function getPresignedUrl(rawUrl) {
    const url = new URL(rawUrl)
    const key = url.pathname.replace(/^\/+/, '')

    return s3.getSignedUrlPromise('getObject', {
        Bucket: 'lithium-60',
        Key:     key,
        Expires: 300
    })
}
